<div class="PGResourceViewTableConfig">
    <div class="container-fluid">
        <div class="row">
            <label class="col-2">
                getRowStatus
            </label>
            <div class="col">
                <textarea class="form-control" [(ngModel)]="view.config.getRowStatus" title="function($row) {{'{\n' + (view.config.getRowStatus || '')  + '\n}'}}"></textarea>
            </div>
        </div>
        <div class="row PGAdmin-Header PGAdmin-Permissions">
            <div class="col-2">COLUMN</div>
            <div class="col-1">TYPE</div>
            <div class="col"></div>
            <div class="col-1"></div>
        </div>

        @for (column of view.config.columns; track column; let i = $index) {
            <div class="row PGAdmin-Permissions">
                @if (isFieldColumn(column)) {
                    <label class="col-2">
                        {{column.field}}
                    </label>
                    <div class="col-1"><b>field</b></div>
                    <div class="col">
                        @if (canFieldSum(column.field)) {
                            <div class="PGResourceViewTableConfig-DisplayOption"><input type="checkbox" [(ngModel)]="column.sum"/> sum</div>
                        }
                    </div>
                }
                @if (isRoleviewColumn(column)) {
                    <ng-container class="row PGAdmin-Permissions">
                        <label class="col-2">
                            <input class="form-control" [(ngModel)]="column.name"/>
                        </label>
                        <div class="col-1"><b>roleview</b></div>
                        <div class="col">
                            <input class="form-control" [(ngModel)]="column.roleview"/>
                        </div>
                    </ng-container>
                }
                @if (isClusterColumn(column)) {
                    <ng-container class="row PGAdmin-Permissions">
                        <label class="col-2">
                            <input class="form-control" [(ngModel)]="column.name"/>
                        </label>
                        <div class="col-1"><b>cluster</b></div>
                        <div class="col">
                            <input class="form-control" [(ngModel)]="column.cluster" (ngModelChange)="disableInsertedOptions()"/>
                        </div>
                    </ng-container>
                }
                <div class="col-2">
                    <div class="text-end">
                        <button class="btn btn-white p-1 me-1" [disabled]="i <= 0" (click)="moveConfig(i, i - 1);">
                            <i class="fa-regular fa-chevron-up fa-fw"></i>
                        </button>
                        <button class="btn btn-white p-1 me-1" [disabled]="i >= view.config.columns.length - 1" (click)="moveConfig(i, i + 1);">
                            <i class="fa-regular fa-chevron-down fa-fw"></i>
                        </button>
                        <button class="btn btn-white p-1" (click)="removeColumn(column);">
                            <i class="fa-regular fa-trash fa-fw text-danger"></i>
                        </button>
                    </div>
                </div>
            </div>
        }

        <div class="row PGResourceViewTableConfig-AddNew">
            <div class="col-2">
                <button class="btn btn-sm btn-primary" (click)="addNewColumn()">
                    <i class="fa-regular fa-plus"></i>
                </button>
            </div>
            <div class="col">
                <app-pg-select [options]="viewTypeOptions" [(ngModel)]="newColumnType" display="oneLine" [required]="true"></app-pg-select>
            </div>
        </div>
    </div>
</div>
